import type { PersonalizationResponse } from '../types';

export const isSiteOptedOut = async (cloudId: string): Promise<boolean> => {
	const siteTraits = await fetchSitePersonalization(cloudId);
	const optoutTraitValue = siteTraits.find((trait) => trait.name === 'optout_all_messages')?.value;
	return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};

const getPersonalizationSiteTraitsUrl = (cloudId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;

const fetchSitePersonalization = async (
	cloudId: string,
): Promise<PersonalizationResponse['attributes']> => {
	const response = await fetch(getPersonalizationSiteTraitsUrl(cloudId), {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	const { attributes } = await response.json();
	return attributes;
};
